module.exports = __webpack_public_path__ + "img/ic_checkbox.814ef351.svg";